var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"typeahead-suggestions",class:_vm.classes,attrs:{"id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.formatValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }